import { render } from "./settingsidebar.html?vue&type=template&id=70bd1bb1&scoped=true&external"
import script from "./settingsidebar.vue?vue&type=script&lang=js"
export * from "./settingsidebar.vue?vue&type=script&lang=js"

import "./settingsidebar.vue?vue&type=style&index=0&id=70bd1bb1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70bd1bb1"]])

export default __exports__